/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorfallbackcopyfailed3Inputs */



/**
* | output |
* | --- |
* | "✗ Failed" |
*
* @param {Errorfallbackcopyfailed3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const errorfallbackcopyfailed3 = /** @type {((inputs?: Errorfallbackcopyfailed3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorfallbackcopyfailed3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("✗ Failed")
	if (locale === "es") return /** @type {LocalizedString} */ ("✗ Error")
	return /** @type {LocalizedString} */ ("✗ Не удалось")
});
export { errorfallbackcopyfailed3 as "errorFallbackCopyFailed" }